import { useRef, useEffect } from 'react';
import {
  TUIChatEngine,
  TUIStore,
  StoreName,
  TUIConversationService,
  IConversationModel,
} from '@tencentcloud/chat-uikit-engine';
import {
  Chat,
  ChatHeader,
  MessageList,
  MessageInput,
  Profile,
  ConversationList,
  ChatSetting,
} from '@tencentcloud/chat-uikit-react';
import { UIKitProvider } from '@tencentcloud/uikit-base-component-react';
import { TUICallKit } from '@tencentcloud/call-uikit-react';
import cs from 'classnames';
import { useOutlet } from '@/context/OutletContext';
import { reportEvent, REPORT_KEY } from '@/utils/aegis';

import './InboxWeb.scss';

function InboxWeb() {
  const {
    theme,
    language,
    chat,
    loginUserID,
  } = useOutlet();
  const isFirstRender = useRef<boolean>(false);

  useEffect(() => {
    TUIStore.watch(StoreName.CONV, {
      conversationList: onConversationListUpdated,
    });
    return () => {
      TUIStore.unwatch(StoreName.CONV, {
        conversationList: onConversationListUpdated,
      });
    };
  }, []);

  function onConversationListUpdated(conversationList: IConversationModel[]) {
    if (isFirstRender.current) {
      return;
    }
    // default open first group chat
    const firstGroupChat = conversationList.find((item: IConversationModel) => item.type === TUIChatEngine.TYPES.CONV_GROUP);
    if (firstGroupChat && firstGroupChat.conversationID) {
      const conversationID = 'C2CRobot11';
      TUIConversationService.switchConversation(conversationID);
      isFirstRender.current = true;
    }
  }

  const callButtonClicked = (callMediaType?: number) => {
    if (callMediaType === 2) {
      reportEvent({ actionKey: REPORT_KEY.VIDEO_CALL, loginUserID });
    } else {
      reportEvent({ actionKey: REPORT_KEY.AUDIO_CALL, loginUserID });
    }
  };
  const callStyle: React.CSSProperties = {
    position: 'fixed',
    width: '800px',
    top: '50%',
    left: '50%',
    zIndex: '999',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <div className={cs('web-container', theme)}>
      <UIKitProvider chat={chat} language={language} theme={theme}>
        <TUICallKit style={callStyle} />
        <div className="sample-chat-left-container">
          <Profile />
          <ConversationList />
        </div>
        <Chat callButtonClicked={callButtonClicked}>
          <ChatHeader enableCall={true} />
          <MessageList />
          <MessageInput />
        </Chat>
        <ChatSetting />
      </UIKitProvider>
    </div>
  );
}

export default InboxWeb;
